import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { Option } from '../option';

export interface OptionListFieldModel extends BaseFieldModel {
  defaultValue: string[] | undefined;
  options: Option[];
  multiSelection: boolean | undefined;
  type: FieldType.OptionList;
}

export class OptionListField extends BaseField implements OptionListFieldModel {
  public defaultValue: string[] | undefined;
  public options: Option[] = [];
  public multiSelection: boolean | undefined;
  public type: FieldType.OptionList = FieldType.OptionList;

  constructor(cultures: string[]) {
    super(FieldType.OptionList, cultures);
  }
}
